// Tiny controller: any `change` event bubbling up to this element causes
// the form to submit. Use on filter forms where every control should
// commit instantly — kills the need for an Apply button.
//
// Pair with other Stimulus controllers that mutate sibling controls
// (e.g. filter-scope), as long as they run before the bubble reaches
// this controller — Stimulus dispatches action handlers in DOM order,
// so a controller on an inner element fires before one on the form.

import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLFormElement> {
  connect(): void {
    this.element.addEventListener("change", this.handle)
  }
  disconnect(): void {
    this.element.removeEventListener("change", this.handle)
  }

  private handle = (e: Event): void => {
    // Submit on the next microtask so any synchronous DOM mutations from
    // sibling controllers (e.g. filter-scope clearing dependent selects)
    // settle into the form's submitted values first.
    queueMicrotask(() => this.element.requestSubmit?.() ?? this.element.submit())
  }
}
